import React, { useCallback, useEffect, useState } from "react";

import QRCode from "react-qr-code";

import { useLocation } from "react-router-dom";

import { makeGet } from "@culturehq/client";
import { Icon, ModalDialog } from "@culturehq/components";

import facebook from "images/social/facebook.svg";

import { useProfile } from "app/context";
import { Trans } from "app/utils";
import getSubdomain from "app/utils/getSubdomain";

import ChqModalDialog from "components/common/ChqModalDialog";

const StoryShareFacebook = ({
  approvedForSocial, children, story
}) => {
  const { profile } = useProfile();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [shareMessage, setShareMessage] = useState();

  useEffect(
    () => {
      const paths = location.pathname.split("/");
      if (paths[paths.length - 1] === "share" && profile?.userFacebook?.name && `${story.id}` === paths[paths.length - 2]) {
        setOpen(true);
      }
    },
    [location.pathname, profile, story.id]
  );

  useEffect(
    () => {
      const approvedForSocialMessage = approvedForSocial?.approvedForSocialMessages?.find(approvedMessage => approvedMessage.socialType === "facebook");
      if (approvedForSocialMessage?.message?.length > 0) {
        setShareMessage(approvedForSocialMessage.message);
      } else {
        setShareMessage(story.body ? `${JSON.parse(story.body).blocks.map(block => block.text).join("\n")}` : "");
      }
    }, [approvedForSocial, story, profile]
  );

  const onOpen = useCallback(
    () => {
      const facebookSession = async () => {
        let locationUrl;
        if (location.pathname.startsWith("/stories/trend")) {
          locationUrl = `${location.pathname}/story/${story.id}/share`;
        } else {
          locationUrl = `/stories/${story.id}/share`;
        }

        const { url } = await makeGet("/facebook/integration", { url: locationUrl });
        window.location.href = url;
      };

      if (!profile?.userFacebook?.name) {
        facebookSession();
      }
      setOpen(true);
    },
    [setOpen, profile, location.pathname, story.id]
  );

  const onClose = useCallback(
    () => {
      setOpen(false);
    },
    [setOpen]
  );

  return (
    <>
      {children && (
        <div onClick={onOpen} role="button" tabIndex={0}>
          {children}
        </div>
      )}
      {open && (
        <ChqModalDialog onClose={onClose} className="FacebookShareModal">
          <ModalDialog.Heading onClose={onClose}>
            <img className="social-icon" src={facebook} alt="Facebook icon" />{" "}
            <Trans>Share to Facebook</Trans>
          </ModalDialog.Heading>
          <ModalDialog.Body>
            <div className="TipContainer">
              <Icon icon="info" />
              <div>
                <p>
                  <Trans>
                    Facebook requires you to share from mobile. Scan the
                    QR code below to share this story from our mobile app.
                  </Trans>
                </p>
              </div>
            </div>
            <div className="Main-Container">
              <div className="Left-Container">
                <p>
                  <strong><Trans>Scan this QR code</Trans></strong>
                  <br />
                  <strong><Trans>to finish sharing</Trans></strong>
                </p>
                <svg className="Arrow" width="22px" height="22px" viewBox="0 0 156 156">
                  <g fill="rgb(0,0,0)">
                    <path d="m99 32.11c-25.22-10.36-50.8 2-62.67 25.2-12.08 23.62-10.59 54.9 2.06 77.91 2.64 4.79 9.33.59 7.19-4.2-9.34-20.93-11.15-45.7-2-67a47.94 47.94 0 0 1 19.26-22.3c11.25-6.91 23-5.86 35.47-4.79 3 .26 2.99-3.86.69-4.82z" />
                    <path d="m126.56 36.18c-10.17-6.91-21-15.32-33.42-17.48a1.75 1.75 0 0 0 -.93 3.37c10.44 4.1 19.32 10.16 28.2 16.77-5.64 4.49-12.15 8.18-17 13.46a2.71 2.71 0 0 0 3.27 4.23 92.87 92.87 0 0 0 20.44-15.75 3 3 0 0 0 -.56-4.6z" />
                  </g>
                </svg>
              </div>
              {typeof shareMessage !== "undefined" && shareMessage !== null && (
                <div className="QR-Container">
                  <QRCode
                    bgColor="transparent"
                    className="QR"
                    fgColor="#000000"
                    size={172}
                    value={`https://${getSubdomain()}.culturehq.com/social/${story.id}/facebook`}
                  />
                </div>
              )}
            </div>
          </ModalDialog.Body>
        </ChqModalDialog>
      )}
    </>
  );
};

export default StoryShareFacebook;
